import YoutubeEmbed from "./YoutubeEmbed";

function AboutColFour() {
  return (
    <section className="about-column" id="colFour">
      <div className="about-column-inner">
        
        <div className="about-column-content">
          <div className="about-section" id="superstudio_talks">
            <h3>Winter 2026 Superstudio Talks</h3>


<YoutubeEmbed url="https://www.youtube.com/watch?v=VAnhw0yVSiI" />
<p>
  <strong>Term 2 Wrap Event</strong>
  <h5>May 14, 2026</h5>
</p>
     

           <YoutubeEmbed url="https://youtu.be/ultvtEWTkMg?si=DwIbB3E3lTX9JyNw" />
<p><strong>Robert Raynor, Toronto Metropolitan University:<br />House [verb]</strong>
<h5>March 19, 2026</h5></p>

<YoutubeEmbed url="https://youtu.be/u0q-Ojgv7gw?si=NYDM6Lfn9L2T4diz" />
<p><strong>Mauricio Soto Rubio, University of Calgary:<br />The Porous Dwelling</strong>
<h5>March 12, 2026</h5></p>

<YoutubeEmbed url="https://youtu.be/i4yxH4s9Jxk?si=yohLW3gCRQ_ioyc3" />
<p><strong>Shawn Bailey, University of Manitoba:<br />Relational Housing</strong>
<h5>March 5, 2026</h5></p>

<YoutubeEmbed url="https://youtu.be/ImRJrzgED20?si=-TZ5wSh9CW7aUBCa" />
<p><strong>Cheryl Giraudy, OCAD University:<br />Residential Inclusivity: Community &amp; Placemaking</strong>
<h5>February 26, 2026</h5></p>

<YoutubeEmbed url="https://youtu.be/iFdIu2AtyjA?si=52g1-2O9gwRHsoaz" />
<p><strong>Shirley Shen + Travis Hanks, Haeccity Studio, BCIT:<br />Collective Typologies for Anti-Speculative Housing</strong>
<h5>February 5, 2026</h5></p>

<YoutubeEmbed url="https://youtu.be/gNeDUu_mj-E?si=Bv9kbQK4tZupqmmr" />
<p><strong>Cheryl Atkinson, Toronto Metropolitan University:<br />Living Close</strong>
<h5>January 29, 2026</h5></p>

<YoutubeEmbed url="https://youtu.be/sDt5bwhQet8?si=gwFtbVnaz2S3zsa7" />
<p><strong>Anne Cormier + Frédéric Dubé, Université de Montréal:<br />Habiter Montréal</strong>
<h5>January 22, 2026</h5></p>

<YoutubeEmbed url="https://youtu.be/LinSvs2b1ys?si=KKWaWwgc0TBfDZKR" />
<p><strong>David Fortin, AAHA Organizer / University of Waterloo:<br />Housing and Reconciliation</strong>
<h5>January 8, 2026</h5></p>

<YoutubeEmbed url="https://www.youtube.com/watch?v=v74bBw4VKT4" />
<p>
  <strong>Term 2 Launch Event</strong>
  <h5>January 8, 2026</h5>
</p>
       

            <h3>Fall 2025 Superstudio Talks</h3>

            


<YoutubeEmbed url="https://www.youtube.com/watch?v=YwI2x5YA7W0" />
<p>
  <strong>Term 1 Wrap Event</strong>
  <h5>December 17, 2025</h5>
</p>
         <YoutubeEmbed url="https://www.youtube.com/watch?v=DdrUNEaNaa0" />
<p>
  <strong>Karen Kubey:<br />The Right to Housing is Architectural</strong>
  <h5>November 6, 2025</h5>
</p>

<YoutubeEmbed url="https://www.youtube.com/watch?v=LqUiKCtNMAM" />
<p>
  <strong>Matthew Soules:<br />Architecture and Financialization</strong>
  <h5>October 30, 2025</h5>
</p>

<YoutubeEmbed url="https://www.youtube.com/watch?v=fQABQzZLuH0" />
<p>
  <strong>Inge Roecker:<br />Homing</strong>
  <h5>October 24, 2025</h5>
</p>

<YoutubeEmbed url="https://www.youtube.com/watch?v=WDa7_JV8E6I" />
<p>
  <strong>Barry Johns:<br />BAAKFIL and the Housing Crisis</strong>
  <h5>October 20, 2025</h5>
</p>

<YoutubeEmbed url="https://www.youtube.com/watch?v=hft4HpPxRrw" />
<p>
  <strong>Adrian Blackwell:<br />Infill as Relational Architecture</strong>
  <h5>October 2, 2025</h5>
</p>

<YoutubeEmbed url="https://www.youtube.com/watch?v=bQcm1cJV6Hw" />
<p>
  <strong>Term 1 Launch Event</strong>
  <h5>September 5, 2025</h5>
</p>
          </div>
          <div className="about-section" id="participating_institutions">
            <h3 className="about-sticky">Participating Institutions</h3>
            <ul>
              <li><a href="https://www.athabascau.ca/science-and-technology/about/discover-our-academic-disciplines/raic-centre-for-architecture.html" target="_blank" rel="noreferrer">Athabasca University</a></li>
              <li><a href="https://www.bcit.ca/programs/architectural-science-bachelor-of-architectural-science-full-time-8050btech/" target="_blank" rel="noreferrer">British Columbia Institute of Technology</a></li>
              <li><a href="https://architecture.carleton.ca/" target="_blank" rel="noreferrer">Carleton University</a></li>
              <li><a href="https://www.dal.ca/faculty/architecture-planning/school-of-architecture.html" target="_blank" rel="noreferrer">Dalhousie University</a></li>
              <li><a href="https://laurentian.ca/program/architecture" target="_blank" rel="noreferrer">Laurentian University</a></li>
              <li><a href="https://www.mcgill.ca/architecture/" target="_blank" rel="noreferrer">McGill University</a></li>
              <li><a href="https://admissions.ocadu.ca/program/environmental-design" target="_blank" rel="noreferrer">OCAD University</a></li>
              <li><a href="https://www.torontomu.ca/architecture/" target="_blank" rel="noreferrer">Toronto Metropolitan University</a></li>
              <li><a href="https://architecture.umontreal.ca/" target="_blank" rel="noreferrer">Université de Montréal</a></li>
              <li><a href="https://sala.ubc.ca/" target="_blank" rel="noreferrer">University of British Columbia</a></li>
              <li><a href="https://sapl.ucalgary.ca/" target="_blank" rel="noreferrer">University of Calgary</a></li>
              <li><a href="https://umanitoba.ca/architecture/" target="_blank" rel="noreferrer">University of Manitoba</a></li>
              <li><a href="https://www.daniels.utoronto.ca/" target="_blank" rel="noreferrer">University of Toronto</a></li>
              <li><a href="https://uwaterloo.ca/architecture/" target="_blank" rel="noreferrer">University of Waterloo</a></li>
            </ul>
          </div>
          <div className="about-section" id="sponsor">
            <h3>Sponsor</h3>
            <ul>
              <li><a href="https://architecturecanada.ca/" target="_blank" rel="noreferrer">Canadian Council of University Schools of Architecture</a></li>
            </ul>
          </div>
          <div className="about-section" id="organizer">
            <h3>Organizer</h3>
            <ul>
              <li><a href="https://aaha.ca/" target="_blank" rel="noreferrer">Architects Against Housing Alienation</a></li>
            </ul>
          </div>
          <h3>Enquiries</h3>
          <ul>
            <li><a href="mailto:info@aaha.ca">info@aaha.ca</a></li>
          </ul>
<div className="about-section" id="resources">
                <h3 className="about-sticky">Resources</h3>
            <ul>
              <li>Anderson, Sean, Mabel Wilson, and Museum of Modern Art (New York, N.Y.), eds. <em>Reconstructions: Architecture and Blackness in America</em>. New York, NY: The Museum of Modern Art, 2021.</li>
              <li>Bhandar, Brenna. <em>Colonial Lives of Property: Law, Land, and Racial Regimes of Ownership</em>. Global and Insurgent Legalities. Durham: Duke University Press, 2018.</li>
              <li>Blackwell, Adrian, and David Fortin, eds. <em>Scapegoat 12/13: C\a\n\a\d\a</em>, 2020.</li>
              <li>Blondin, George. <em>Yamoria the Lawmaker: Stories of the Dene</em>. 1st ed. Edmonton: NeWest Press, 1997.</li>
              <li>Bozikovic, Alex, Cheryll Case, John Lorinc, and Annabel Vaughan, eds. <em>House Divided: How the Missing Middle Can Solve Toronto's Affordability Crisis</em>. First edition. Toronto: Coach House Books, 2019.</li>
              <li>Brown, Joanna. <em>The Book of Homelessness</em>. Accumulate, n.d.</li>
              <li>Burton, Virginia Lee. <em>The Little House</em>. Boston: Houghton Mifflin co, 1942.</li>
              <li>Center for Urban Pedagogy. "<a href="https://welcometocup.org/projects/what-is-affordable-housing" target="_blank" rel="noreferrer">What Is Affordable Housing?</a>" CUP. Accessed January 11, 2025.</li>
              <li>Chibber, Vivek. <em>Confronting Capitalism: How the World Works and How to Change It</em>. The Jacobin Series. London: Verso, 2022.</li>
              <li>Christensen, Julia. <em>No Home in a Homeland: Indigenous Peoples and Homelessness in the Canadian North</em>. Vancouver; Toronto: UBC Press, 2017.</li>
              <li><em>Colonization Road</em>. Toronto: Decolonization Road Productions Inc, 2016.</li>
              <li>Cook, Greg, Cathy Crowe, Shawn Micallef, and Robyn Maynard, eds. <em>Displacement City: Fighting for Health and Homes in a Pandemic</em>. Toronto; Buffalo; London: Aevo UTP, an imprint of University of Toronto Press, 2022.</li>
              <li><a href="https://www-nfb-ca.eu1.proxy.openathens.net/film/co-op-housing-the-best-ove-we-ever-made/" target="_blank" rel="noreferrer">Co-Op Housing: The Best Move We Ever Made</a>. Accessed April 5, 2022.</li>
              <li>Coulthard, Glen Sean. <em>Red Skin, White Masks: Rejecting the Colonial Politics of Recognition</em>. Indigenous Americas. Minneapolis, MN: University of Minnesota Press, 2014.</li>
              <li>Day, Kirsten, Peggy Deamer, and Andrea Dietz. <em>The Organizer's Guide to Architecture Education</em>. London; New York: Routledge, 2024.</li>
              <li>David Baker Architects. <em>9 Ways to Make Housing for People</em>. First edition. Novato, Calif.: ORO Editions, 2022.</li>
              <li>Davis, Dr John Emmeus, ed. <em>The Community Land Trust Reader</em>. Cambridge: Lincoln Institute of Land Policy, 2014.</li>
              <li>Davis, John Emmaus, and Hubert Lavallée. <em>Manuel d'antispéculation immobilière: Une introduction aux fiducies foncières</em>. Montréal (Québec) Escalquens: Écosociété, 2014.</li>
              <li>Davis, John Emmeus, Line Algoed, and María E. Hernández-Torrales, eds. <em>On Common Ground: International Perspectives on the Community Land Trust</em>. Terra Nostra Press, n.d.</li>
              <li>Folco, Jonathan Durand. <em>À nous la ville!: Traité de municipalisme</em>. Montréal (Québec): Écosociété, 2017.</li>
              <li>George, Henry. <em>Progress and Poverty</em>. New York: Doubleday & McLure Co., 1881.</li>
              <li>Graeber, David, and D. Wengrow. <em>The Dawn of Everything: A New History of Humanity</em>. First American edition. New York: Farrar, Straus and Giroux, 2021.</li>
              <li>Grant, Shauntay. <em>Africville</em>. Groundwood Books Ltd, n.d.</li>
              <li>Greer, Allan. <em>Property and Dispossession: Natives, Empires and Land in Early Modern North America</em>. Cambridge University Press, 2017.</li>
              <li>Hayden, Dolores. <em>The Grand Domestic Revolution</em>. Cambridge, Mass.; London, Eng: MIT Press, 1981.</li>
              <li>Joseph, Robert P. C. <em>21 Things You May Not Know about the Indian Act</em>. Port Coquitlam, BC: Indigenous Relations Press, 2018.</li>
              <li>Justice, Daniel Heath, and Jean M. O'Brien, eds. <em>Allotment Stories: Indigenous Land Relations under Settler Siege</em>. Minneapolis: University of Minnesota Press, 2021.</li>
              <li>Kiddle, Rebecca, Luugigyoo Patrick Stewart, and Kevin O'Brien. <em>Our Voices. II: The de-Colonial Project</em>. First edition. New York: ORO Editions, 2021.</li>
              <li>———. <em>Our Voices: Indigeneity and Architecture</em>. First edition. San Francisco Bay Area: ORO Editions, 2018.</li>
              <li>Kimmerer, Robin Wall. <em>Braiding Sweetgrass</em>. Second hardcover edition. Minneapolis, Minnesota: Milkweed Editions, 2020.</li>
              <li>Lafferty, Catherine. <em>This House Is Not a Home</em>. Halifax; Winnipeg: Roseway Publishing, 2022.</li>
              <li>Larcombe, Linda, et al. "<em>Sekuwe (My House): Building Health Equity through Dene First Nations Housing Designs</em>." <em>International Journal of Circumpolar Health</em> 79, no. 1 (2020): 1717278. <a href="https://doi.org/10.1080/22423982.2020.1717278" target="_blank" rel="noreferrer">https://doi.org/10.1080/22423982.2020.1717278</a>.</li>
              <li>Law, Victoria, and China Martens, eds. <em>Don't Leave Your Friends behind</em>. Oakland: PM Press, 2012.</li>
              <li>Lesser, Beth. <em>Dancehall: The Rise of Jamaican Dancehall Culture</em>. Edited by Stuart Baker. Soul Jazz Books, n.d.</li>
              <li>Lorinc, John, and Jay Pitter, eds. <em>Subdivided: City-Building in an Age of Hyper-Diversity</em>. Toronto: Coach House Books, 2016.</li>
              <li>Madden, David J., and Peter Marcuse. <em>In Defense of Housing: The Politics of Crisis</em>. London; New York: Verso, 2016.</li>
              <li>Martin, Reinhold, Jacob Moore, and Susanne Schindler, eds. <em>The Art of Inequality</em>. New York: Temple Hoyne Buell Center, Columbia University, 2015.</li>
              <li>McAdam, Sylvia. <em>Nationhood Interrupted</em>. Saskatoon, SK: Purich Publishing Limited, 2015.</li>
              <li>McCamant, Kathryn, and Charles Durrett. <em>Creating Cohousing</em>. Gabriola Island, BC: New Society Publishers, 2011.</li>
              <li>Nielsen-Fernlund, Susin. <em>No Fixed Address</em>. New York: Wendy Lamb Books, 2018.</li>
              <li>Peterson, Lois, Taryn Gee, and Kirstie Hudson. <em>Shelter: Homelessness in Our Community</em>. Victoria: Orca Book Publishers, 2021.</li>
              <li>Simpson, Leanne Betasamosake. <em>A Short History of the Blockade</em>. Edmonton: University of Alberta Press, 2021.</li>
              <li>Soules, Matthew. <em>Icebergs, Zombies, and the Ultra Thin</em>. New York: Princeton Architectural Press, 2021.</li>
              <li>Spade, Dean. <em>Mutual Aid</em>. London; Brooklyn, NY: Verso, 2020.</li>
              <li>Stevens, Sara. <em>Developing Expertise</em>. New Haven: Yale University Press, 2016.</li>
              <li>Wade, Jill. <em>Houses for All</em>. Vancouver: UBC Press, 1994.</li>
              <li>Walcott, Rinaldo. <em>On Property</em>. Windsor, Ontario: Biblioasis, 2021.</li>
              <li>Wilson, Shawn. <em>Research Is Ceremony</em>. Nova Scotia: Fernwood Publishing, 2008.</li>
              <li>Yahgulanaas, Michael Nicoll and Wangari Maathai. <em>The Little Hummingbird</em>. Vancouver: Greystone, 2010.</li>
              <li>Yakeleya, Elizabeth, et al., eds. <em>We Remember the Coming of the White Man</em>. Calgary: Durvile & UpRoute Books, 2020.</li>
              <li>Yellowhead Institute, Hayden King, and Shiri Pasternak. "<em>Land Back: A Yellowhead Institute Red Paper</em>," 2019.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutColFour;
